module.exports = __webpack_public_path__ + "static/Turnkey Group-33913ad78760a8a1bf881ba60b28954e.jpg";